import { MutationTree } from "vuex";
import { PEDIDO } from "./types";

type PedidoCompletadosMutationTree = MutationTree<PEDIDO>;

export const mutations: PedidoCompletadosMutationTree = {};
